import { LoopbackHttpTransport } from '@ofs-vuex-crud';
import config from '@/config';

const providerInstance = new LoopbackHttpTransport({ apiBase: config.apiBase });

export default providerInstance;
